/**
 * 基本情報
 */
export class BasicInfo {
    // private変数 --------------------------------------------------------
    private m_ContractNumber: string = null; // 契約証番号
    private m_InsuranceType: string = null; // 保険種類
    private m_Plan: string = null; // 契約プラン
    private m_InsuranceFee: number = 0; // 合計保険料（全員分）
    private m_InsurancePeriod: string = null; // 保険期間
    private m_ApplicationDate: string = null; // 申込日
    // --------------------------------------------------------------------

    // プロパティ --------------------------------------------------------------------
    /** 契約証番号 */
    public get contractNumber(): string { return this.m_ContractNumber; } public set contractNumber(contractNumber: string) { this.m_ContractNumber = contractNumber; }
    /** 保険種類 */
    public get insuranceType(): string { return this.m_InsuranceType; } public set insuranceType(insuranceType: string) { this.m_InsuranceType = insuranceType; }
    /** 契約プラン */
    public get plan(): string { return this.m_Plan; } public set plan(plan: string) { this.m_Plan = plan; }
    /** 合計保険料（全員分） */
    public get insuranceFee(): number { return this.m_InsuranceFee; } public set insuranceFee(insuranceFee: number) { this.m_InsuranceFee = insuranceFee; }
    /** 保険期間 */
    public get insurancePeriod(): string { return this.m_InsurancePeriod; } public set insurancePeriod(insurancePeriod: string) { this.m_InsurancePeriod = insurancePeriod; }
    /** 申込日 */
    public get applicationDate(): string { return this.m_ApplicationDate; } public set applicationDate(applicationDate: string) { this.m_ApplicationDate = applicationDate; }
    // --------------------------------------------------------------------

    // コンストラクタ --------------------------------------------------------
    constructor() { }
    // ------------------------------------------------------------------------
}